import React from 'react'

import Button from '@components/designSystem/Button'
import { HorizontalScroller } from '@components/designSystem/HorizontalScroller'

const HorizontalScrollerDemo: React.FC = () => {
  return (
    <section className="w-full max-w-4xl">
      <h2 className="mb-2 text-lg font-bold">Horizontal Scroller</h2>

      <div>
        <h3 className="mb-3 text-md font-semibold">Buttons Example</h3>
        <HorizontalScroller className="w-full">
          <div className="flex gap-2 px-2">
            {Array.from({ length: 15 }).map((_, i) => (
              <Button key={i} variant={i % 4 === 0 ? 'filled' : i % 4 === 1 ? 'outline' : i % 4 === 2 ? 'ghost' : 'dark'}>
                  Button {i + 1}
              </Button>
            ))}
          </div>
        </HorizontalScroller>
      </div>
    </section>
  )
}

export default HorizontalScrollerDemo

